/* eslint-disable */
export interface StateNomenclature {}

export class State implements StateNomenclature {}
